export default {
  mounted(el, binding) {
    // Проверяем, что binding.value является функцией
    if (typeof binding.value !== "function") {
      return;
    }

    // Создаем обработчик события
    function handler(event) {
      // Проверяем, что клик был вне элемента
      if (!el.contains(event.target)) {
        binding.value(event);
      }
    }

    // Сохраняем обработчик в элементе для последующего удаления
    el.__vueClickOutside__ = handler;

    // Добавляем слушатель события
    const clickHandler =
      "ontouchstart" in document.documentElement ? "touchstart" : "click";
    document.addEventListener(clickHandler, handler);
  },

  updated(el, binding) {
    // Обновляем callback если он изменился
    if (typeof binding.value === "function") {
      el.__vueClickOutside__.callback = binding.value;
    }
  },

  unmounted(el) {
    // Удаляем слушатель события при размонтировании компонента
    if (el.__vueClickOutside__) {
      const clickHandler =
        "ontouchstart" in document.documentElement ? "touchstart" : "click";
      document.removeEventListener(clickHandler, el.__vueClickOutside__);
      delete el.__vueClickOutside__;
    }
  },
};
